export function isMAPage(state) {
    return state.isMAPage
}

export function appConfig(state) {
    return state.appConfig
}

export function windowWidth(state) {
    return state.windowWidth
}

export function activeBreakpoints(state) {
    return state.activeBreakpoints
}

export function isDimmed(state) {
    return state.dimmed;
}

export function isLocked(state) {
    return state.locked;
}

export function mobile(state) {
    return state.mobile;
}

export function portableDevice(state) {
    return state.portableDevice;
}

export function nativeScrolling(state) {
    return state.portableDevice;
}

export function mobileSidebarHeightMode(state) {
    return state.mobileSidebarHeightMode
}

export function mobileSidebarHeight(state, getters) {
    const pinDrop = getters.pinDrop;
    const mobileSidebarHeights = {
        minimal: pinDrop.data || pinDrop.loading ? '190px' : '49px',
        middle: '50%',
        full: '100%'
    }
    return mobileSidebarHeights[state.mobileSidebarHeightMode];
}

export function sidebarDetailOpen(state) {
    return state.sidebarDetailOpen
}

export function interimStopMessageVisible(state) {
    return state.interimStopMessageVisible
}

export function deviceSystem() {
    const userAgent = navigator.userAgent;
    if(/android/i.test(userAgent)){
        return 'android';
    }
    if(/iPad|iPhone|iPod/i.test(userAgent)){
        return 'ios';
    }
    return false
}

export function mobileSearchVisible(state) {
    return state.mobileSearchVisible
}

export function dialogAlreadyVisible(state) {
    return state.dialogAlreadyVisible
}